module.exports = {
  dashboard: '/app',
  login: '/login-firebase',
  register: '/register-firebase',
  market: '#',
  task: '/app/pages/task',
  profile: '/app/pages/user-profile',
  calendar: '/app/pages/calendar',
  email: '/app/pages/email',
  twitter: 'https://twitter.com/ilham_meidi',
  github: 'https://github.com/ilhammeidi',
  pinterest: 'https://id.pinterest.com/ilhammeidi/',
  linkedin: 'https://www.linkedin.com/in/ilhammeidi',
  buy: 'https://themeforest.net/item/enlite-prime-reactjs-fullstack-website-template/23803960'
};
